import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  errorMessage: null,
  message: null,
  show: false,
  loadNotificationEntries: false,
  notificationCenterEntries: [],
});

export const closeNotification = createAction('CLOSENOTIFICATION');
export const errorNotification = createAction('ERRORNOTIFICATION');
export const successNotification = createAction('SUCCESSNOTIFICATION');

export const loadNotificationCenterEntriesAction = createAction('loadNotificationCenterEntriesAction');
export const loadNotificationCenterEntriesSuccessAction = createAction('loadNotificationCenterEntriesSuccessAction');
export const loadNotificationCenterEntriesFailedAction = createAction('loadNotificationCenterEntriesFailedAction');

export const updateNotificationEntryStateAction = createAction('updateNotificationEntryStateAction');
export const setNotificationStates = createAction('setNotificationStates');


const setNotificationCenterEntries = (state, entries) => state.merge({
  notificationCenterEntries: entries,
});

// const setStates = (state, entryStates) => {
//   var entries = state.notificationCenterEntries.asMutable({ deep: true });

//   for(var i = 0; i < entries.length; i++) {
//     var entryState = entryStates.find(f => f.id === entries[i].id);

//     if (entryState) {
//       entries[i].state = entryState.state;
//     }
//   }

//   return state.merge({
//     notificationCenterEntries: entries,
//   })

// }


const reducers = createReducer({
  [errorNotification]: (state, errorMessage) =>
    state.merge({ errorMessage, message: null, show: true }),
  [successNotification]: (state, message) =>
    state.merge({ message, errorMessage: null, show: true }),
  [closeNotification]: state => state.merge({ show: false }),
  [setNotificationStates]: setNotificationCenterEntries,
  [loadNotificationCenterEntriesAction]: state => state.merge({ loadNotificationEntries: true }),
  [loadNotificationCenterEntriesSuccessAction]: setNotificationCenterEntries,
  [loadNotificationCenterEntriesFailedAction]: state => state.merge({ loadNotificationEntries: false }),

}, INITIAL_STATE);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/notification.reducers.js